export default "__VITE_ASSET__DVXVBVol__"